import { useContext } from 'react'

import { DashboardContext } from '@presentation/contexts'

export const useDashboard = () => {
  const sidebar = useContext(DashboardContext)

  return sidebar
}
